function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.933,17.6a.874.874,0,0,1,.294.654v2.135a.307.307,0,0,0,.3.3h.513a.877.877,0,1,1,0,1.754h-.513a2.06,2.06,0,0,1-2.057-2.057V18.645L11.152,17.47a.877.877,0,0,1,0-1.311l1.323-1.175v-1.72a2.06,2.06,0,0,1,2.057-2.057h.513a.877.877,0,1,1,0,1.754h-.513a.307.307,0,0,0-.3.3v2.115a.878.878,0,0,1-.294.656l-.88.781Zm8.63-.127L21.24,18.644v1.741a2.06,2.06,0,0,1-2.057,2.057h-.512a.877.877,0,1,1,0-1.754h.512a.308.308,0,0,0,.3-.3V18.249a.875.875,0,0,1,.294-.655l.88-.782-.88-.781a.878.878,0,0,1-.294-.656V13.262a.308.308,0,0,0-.3-.3h-.512a.877.877,0,1,1,0-1.754h.512a2.06,2.06,0,0,1,2.057,2.057v1.721l1.323,1.175a.877.877,0,0,1,0,1.311Z",
  transform: "translate(-10.857 -11.205)"
});

function SvgBrackets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 11.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrackets);
export default __webpack_public_path__ + "static/media/brackets.d36165df.svg";
export { ForwardRef as ReactComponent };